import { StaatenkennungModel } from "../../../api";

export const convertLaenderKuerzelToBezeichnung = (kuerzel: string | undefined, laender?: Array<StaatenkennungModel>) => {
    if (!kuerzel) {
      return "";
    } else {
      if (laender) {
        return laender?.find((element) => element.iso?.toLowerCase() === kuerzel.toLowerCase())?.bezeichnung;
      } else {
        return kuerzel;
      }
    }
  };

export  const convertLaenderBezeichnungToKuerzel = (
    bezeichnung: string | undefined,
    laenderdaten: Array<StaatenkennungModel>
  ): string | undefined => {
    return bezeichnung
      ? laenderdaten?.find((element) => element.bezeichnung?.toLowerCase() === bezeichnung.toLowerCase())?.iso
      : "AT";
  };